import React from 'react';

import classNames from 'classnames';

import ModalBlank from '../../components/ModalBlank';

export default function DialogModal({
  isOpen,
  setIsOpen,
  title,
  message,
  onConfirm,
  type,
  confirmButtonLabel = 'Yes',
  cancelButtonLabel = 'Cancel',
}) {
  return (
    <ModalBlank id="info-modal" modalOpen={isOpen} setModalOpen={setIsOpen}>
      <div className="p-5 flex space-x-4">
        {/* Icon */}
        <div
          className={classNames(
            'w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-indigo-100 dark:bg-indigo-500/30',
            {
              'bg-rose-100 dark:bg-rose-500/30': type === 'danger',
            }
          )}
        >
          <svg
            className={classNames(
              'w-4 h-4 shrink-0 fill-current text-indigo-500',
              {
                'text-rose-500': type === 'danger',
              }
            )}
            viewBox="0 0 16 16"
          >
            <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
          </svg>
        </div>
        {/* Content */}
        <div className="flex-grow">
          {/* Modal header */}
          <div className="mb-2">
            <div className="text-lg font-semibold text-slate-800 dark:text-slate-100">
              {title}
            </div>
          </div>
          {/* Modal content */}
          <div className="text-sm mb-10">
            <div className="space-y-2">
              <p>{message}</p>
            </div>
          </div>
          {/* Modal footer */}
          <div className="flex flex-wrap justify-end space-x-2">
            <button
              type="button"
              className="btn-sm border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-slate-600 dark:text-slate-300"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              {cancelButtonLabel}
            </button>
            <button
              onClick={() => {
                onConfirm?.();
                setIsOpen(false);
              }}
              type="button"
              className={classNames(
                'btn-sm bg-indigo-500 hover:bg-indigo-600 text-white',
                {
                  'bg-rose-500 hover:bg-rose-600': type === 'danger',
                }
              )}
            >
              {confirmButtonLabel}
            </button>
          </div>
        </div>
      </div>
    </ModalBlank>
  );
}
